import Api from './rest/Company';

export default new Api();
